// extracted by mini-css-extract-plugin
export default {"input":"NumberOfLessons_input__KO3FL"};